import React, { useState, memo, useEffect, useMemo, useContext } from "react";
import {
  Row,
  Container,
  Card,
  CardBody,
  Col,
  Table,
  Button,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
  UncontrolledDropdown,
  DropdownToggle ,
  DropdownMenu ,
  DropdownItem 
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import Select from "react-select";
import toast, { Toaster } from 'react-hot-toast';
// Pages
import Breadcrumbs from "../../components/common/Breadcrumb";
import currencies from "../../utils/currency/currency.json";
import {
  attributes,
  transportType
} from "../../utils/constants";
import {calculateTotalShipment } from '../../utils/commenController'
import {
  handleAddProductApi,
  handleAddSubProductApi,
  getAllProductOrSupportingProductApi,
  fetchProductRelateSubProductDetailsApi,
  handleChangeProductStatusApi,
  fetchSingleProductDetailsApi,
  handleAddCategoryApi,
  fetchProductCategoryApi,
  handleAddSubCategoryApi,
  fetchProductSubCategoryApi,
  handleAddProductTypeApi,
  fetchProductTypeApi,
  handleAddProductSeriesApi,
  fetchProductSeriesApi,
  handleAddSubSeriesApi,
  fetchProductSubSeriesApi
  } from "../../api/productApi";
import { getAllActiveManufacturersApi , handleAddVendorApi } from "../../api/vendorApi"
import { handleAddEditDistributorApi } from "../../api/distributorApi"
import { getAllActiveSupportingOrProductsApi } from "../../api/productApi";
import {
  getAllActiveDistributorsApi
} from "../../api/distributorApi"
import { AuthContext } from "../../contexts/AuthContext";
import { useAppSettings } from '../../contexts/AppSettingsContext';
import PaginationComponent from "../../components/common/Pagination";
import PlaceholderImg from '../../assets/images/placeholderImage.png'

const Product = () => {
  const itemsPerPage = process.env.REACT_APP_PAGINATION_ITEMS_PER_PAGE;  
  const { appSettings } = useAppSettings();
  const appName = appSettings?.title ||process.env.REACT_APP_APP_NAME;
  const [modal, setModal] = useState(false);
  const [attributeValues, setAttributeValues] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [storeTags, setStoreTags] = useState([]);
  const [storeProductImages, setStoreProductImages] = useState([]);
  const [products, setAllProducts] = useState([]);
  const [productList, setProductList] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const { authToken } = useContext(AuthContext);
  const [subProductViewModal, setSubProductViewModal] = useState(false);
  const [productData, setProductDetails] = useState({});
  const [isProductEdit , setIsProductEdit] =  useState(false)
  const [activeVendors, setActiveVendors] = useState([]);
  const [selectedVendor ,setSelectedVendor] = useState(null);
  const [selectedVendorCurrency, setSelectedVendorCurrency]  =  useState({})
  const [activeDistributors, setActiveDistributors] = useState([]);
  const [selectedDistributor ,setSelectedDistributor] = useState(null);
  const [selectedDistributorPrice ,setSelectedDistributorPrice] = useState('');
  const [selectedDistributorLeadTime ,setSelectedDistributorLeadTime] = useState('');
  const [selectedDistributorCurrency ,setSelectedDistributorCurrency] = useState({});
  const [selectedDistributors, setSelectedDistributors] = useState([]);
  const [viewMode, setViewMode] = useState("");
  const [productCategories, setProductCategories] = useState([]);
  const [productSubCategories, setProductSubCategories] = useState([]);
  const [productTypes, setProductType] = useState([]);
  const [productSeries, setProductSeries] = useState([]);
  const [productSubSeries, setProductSubSeries] = useState([]);
  const [isMainProductActive , setIsMainProductActive]  = useState(true)
  // # Add category Modal
  const [show, setShow] = useState(false);
  const [mode, setMode] = useState("");
  const [selectedItem, setSelectedItem] = useState("Products");  
  const [distributorAlreadyExist, setIsDistributorAlreadyExist] = useState(false) 
  
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0);


  useEffect(() => {

    fetchAllActiveManufacturer();
    fetchAllActiveDistributor();
    fetchAllCategories();
    fetchAllSubCategories();
    fetchAllProductTypes();
    fetchAllSeries();
    fetchAllSubSeries();
  }, [authToken]);

  useEffect(()=>{
    fetchAllActiveProductsOrSupportingProducts();
  },[isMainProductActive, authToken])
  useEffect(()=>{
  if(authToken){
    let isMainProduct = false;
    if(selectedItem =='Products'){
       isMainProduct = true
    }
    fetchAllProducts(isMainProduct);  
  }
  }, [authToken,currentPage])

  useEffect(()=>{
    if(!isProductEdit){
      addNewProduct.resetForm();
      setStoreTags([]);
      setAttributeValues({});
      setErrorMessage("");
      setSuccessMessage("");
      setStoreProductImages([]);
      setSelectedVendor(null);
      setSelectedDistributor(null)
      setSelectedDistributorPrice('')
      setSelectedDistributorLeadTime('')
      setSelectedDistributorCurrency({});
      setSelectedDistributors([]);
      setSelectedProducts([])
      fetchAllActiveProductsOrSupportingProducts();
    }

  },[isProductEdit ])
  
  // Momizing currency data
  const memoizedCurrencyData = useMemo(() => {
      return currencies.map((currency) => ({
        value: currency.code,
        label: (
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={currency.flag}
              alt={`${currency.name} flag`}
              style={{ width: 20, height: 20, marginRight: 10 }}
            />
            <span>{`${currency.name} (${currency.code})`}</span>
          </div>
        ),
      }));
  }, [currencies]); // Only recalculate when currencies change

  // Function for fetch all products
  async function fetchAllProducts(isMainProduct) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await getAllProductOrSupportingProductApi(authToken, isMainProduct, currentPage, itemsPerPage);
      const responseData  =  response?.data
      if (response?.code == 200) {
        setAllProducts(responseData.products);
        setTotalPages(Math.ceil((responseData?.totalCount || 1) / itemsPerPage));
      }
    } catch (error) {}
  }

  // Function for fetch all products
  async function fetchAllActiveProductsOrSupportingProducts() {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }
      
      let isMainProduct = true;
      if(isMainProductActive){
          isMainProduct = false;
      }

      let response = await getAllActiveSupportingOrProductsApi(authToken, isMainProduct);
      if (response?.code == 200) {
        setProductList(response.data);
      }
    } catch (error) {

    }
  }


  // Function for fetch active Manufacturer
  async function fetchAllActiveManufacturer() {
    try {
      
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await getAllActiveManufacturersApi(authToken);
      if (response?.code == 200) {
        setActiveVendors(response?.data || []);
      }
    } catch (err) {
      console.log("err->", err.message);
    }
  }

  // Function for fetch active Distributors
  async function fetchAllActiveDistributor() {
    try {
      
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await getAllActiveDistributorsApi(authToken);
      if (response?.code == 200) {
        setActiveDistributors(response?.data || []);
      }
    } catch (err) {
      console.log("err->", err.message);
    }
  }

  // Function for fetch product relate sub product based on the product id 
  const fetchProductRelateSubProduct= async(productId) =>{
    try{
      if (!authToken) {
        throw new Error("Token not found.");
      }
      const isQuotation = false;
      let isMainProduct = false;
      if(selectedItem =='Products'){
         isMainProduct = true
      }
      /*
       *Here if is mainProduct true below api will return supporting product data 
       */

      let response = await fetchProductRelateSubProductDetailsApi(authToken, productId, isQuotation, isMainProduct);

      
      if (response?.code == 200) {

        setProductDetails(response?.data || []);
      }
      setViewMode("PRODUCT_RELATE_SUB_PRODUCTS");
      setSubProductViewModal(true);
    }catch(err){
      console.log("err",err.message);
    }
  }


  
  // Function for fetch single  product details based on the  product id 
  const fetchSingleProductDetailsSubProduct= async(productId,isEdit) =>{
    try{
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let isMainProduct = false;
      if(selectedItem =='Products'){
         isMainProduct = true
      }
      let response = await fetchSingleProductDetailsApi(authToken, productId, isMainProduct, isEdit);
      if (response?.code == 200) {
        if(isEdit){
          const responseData =response?.data;
          const isMainProduct = responseData.is_main_product;
          const distributors  = responseData.distributors;
          
          const manufacture =  responseData.manufacturer
          const formattedManufacture  =  {value :  manufacture.id,label : manufacture.name}
          const productImages  =  responseData.image_urls
          const additionalTags  =  responseData.additional_tags_text;
          const manufactureCurrency  = responseData?.currency

          const productAttributes  = responseData?.attributes;
          if(productAttributes){
            let formattedAttributes = {}
            for(let key in productAttributes){
                formattedAttributes[key] = productAttributes[key]
            }
              setAttributeValues(formattedAttributes)
          }

          let formattedData = []
          if(isMainProduct){
            formattedData =  responseData?.supporting_products?.map((item)=>(
              { value :  item.id, label : item.name}
            ))
          }else{
            formattedData =  responseData?.parent_products?.map((item)=>(
              { value :  item.id, label : item.name}
            ))
          }

          
          if(Array.isArray(additionalTags) && additionalTags.length !==0){
            setStoreTags(additionalTags)
          }

          if(distributors){
            let formattedDistributors = distributors?.map((item)=>({id : item.id, price :  item.price, label : item.name ,lead_time : item.lead_time,  currency : {value : item.currency}}))
            const selectedCurrency  =  memoizedCurrencyData.find((item)=>(item.value  === formattedDistributors[0].currency.value))

            setIsDistributorAlreadyExist(true)
            setSelectedDistributors(formattedDistributors)
            setSelectedDistributor({label : formattedDistributors[0].label, value : formattedDistributors[0].id})
            setSelectedDistributorPrice(formattedDistributors[0]?.price || "")
            setSelectedDistributorLeadTime(formattedDistributors[0]?.lead_time || "")
            setSelectedDistributorCurrency(selectedCurrency)
          }else{
            setSelectedDistributor({label : 'No Distributor', value : ''})
          }
          if(manufactureCurrency){
            const selectedCurrency  =  memoizedCurrencyData.find((item)=>(item.value  === manufactureCurrency))
            setSelectedVendorCurrency(selectedCurrency)
          }




          if(Object.keys(productImages).length !==0){
            let formattedProductImage = [];
            for(let key in productImages){
              formattedProductImage.push(({name  : key, file : productImages[key] }))
            }
            setStoreProductImages(formattedProductImage)
          }

          setProductDetails(responseData || {});
          setIsMainProductActive(isMainProduct);
          setSelectedProducts(formattedData);
          setSelectedVendor(formattedManufacture);

        }else{
          setProductDetails(response?.data || []);
        }

      }
      if(isEdit){
        setModal(true)
   
        setIsProductEdit(true)
      }else{
        setViewMode("PRODUCT_DETAILS");
        setSubProductViewModal(true);
      }
    }catch(err){
      console.log("err",err.message);
    }
  }



  
  const addNewProduct = useFormik({
    enableReinitialize : true,
    initialValues: {
      id : productData?.id || "",
      product_code :  productData?.product_code || "",
      name: productData?.name || "",
      category_name: productData?.main_category?.id || "",
      subcategory_name: productData?.sub_category?.id || "",
      product_type_name: productData?.type_category?.id || "",
      product_series_name: productData?.series_category?.id || "",
      product_subseries_name: productData?.subseries_category?.id || "",
      supported_products: [],
      part_number : productData?.part_number || "",
      manufacture:  "",
      currency: "",
      tags: [],
      attributes: {},
      data_sheet: productData?.data_sheet || "",
      user_manual:  productData?.user_manual || "",
      release_date: productData?.release_date || "",
      gpl_price :  productData?.gpl_price || "",
      description: productData?.description || "",
      lead_time:  productData?.lead_time || "",
      distributors: [],
      // Transport and Fees Section
      transport_type : productData?.transport_type || "",
      logistic_fee : productData?.logistic_fee || "",
      custom_fee : productData?.custom_fee  || "",
      total_shipment_charge : 0,
      logistic_buffer_charge : productData?.logistic_buffer_charge || 0,
      // Warranty terms 
      warranty_period: productData?.warranty_period || "",
      warranty_terms: productData?.warranty_terms || "",
      
    },
    validationSchema: Yup.object({
      // currency: isMainProductActive ? Yup.string().required("Currency is required") : '',
      // manufacture : Yup.string().required("Manufacture is required"),
      part_number : Yup.string()
      .matches(/^\S+$/, "Spaces are not allowed"),
    }),
    onSubmit: (values) => {
      console.log("values->", values);
      values.tags = storeTags;
      if(selectedVendorCurrency?.value == ""){
        setErrorMessage("Currency is required.");
        return
      }
      if(selectedDistributor.value !=='' && selectedDistributors.length == 0){
        setErrorMessage("Add selected distributer");
        return
      }

      values.currency  = selectedVendorCurrency.value
      
      if(selectedDistributors.length > 0){
        values.distributors = selectedDistributors?.map((item)=>({id : item.id, price :  item.price, name : item.label,leadTime : item.lead_time,  currency : item.currency.value}))
      }

      setErrorMessage("");
      values.isMainProduct  = isMainProductActive
      values.isEdit  = isProductEdit
      values.manufacture = selectedVendor?.value || "";
      values.attributes = attributeValues;

      if(!selectedVendor){
        setErrorMessage("Manufacture is required");
        return
      }
      if(isMainProductActive){
        // #MAIN PRODUCT
   
        values.supported_products = selectedProducts?.map((item)=>item.value) || []

        

        }else{
          // #SUB PRODUCT
          values.parent_products = selectedProducts?.map((item)=>item.value) || []
        }
        console.log("values--->", values);
        
        handleAddProduct(values);
    },
  });



  // Function handle product add functionality
  async function handleAddProduct(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }

      values.images = {};  // Initialize the images object

      for (let imageData of storeProductImages) {
          let objectKey = "";  // To hold the key related to the File
          let objectValue = null;  // To hold the file value
      
          // Loop through the keys of imageData
          for (let key in imageData) {
              if (imageData.hasOwnProperty(key)) {  
      
                  if (imageData[key] instanceof File) {
                      
                      objectKey =  imageData.name;  // Store the key that corresponds to the file
                      objectValue = imageData[key];  // Store the file itself
                  } else if (typeof imageData[key] === 'string') {
                      // If the value is a string and the key isn't the same as the file's key, add it to images
                      if (objectKey !== key) { // Ensure we don't add file name to images
                          values.images[key] = imageData[key];
                      }
                  }
              }
          }
      
          // After the loop, if we found a File, store it separately
          if (objectKey && objectValue) {
              values[objectKey] = objectValue;  // Store the file object using its key
          }
      }
      



      let response = await handleAddProductApi(values, authToken);
      if (response?.code == 200) {
        setErrorMessage("");
        setSuccessMessage(response.message);
        fetchAllProducts(isMainProductActive);
        if(isMainProductActive){
          setSelectedItem('Products')
        }else{
          setSelectedItem('Supporting Products')
        }
        setModal(false);
      } else {
        setSuccessMessage("");
        setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }
  // <-----------------------START Category------------------------------>
  useEffect(()=>{
      if(addNewProduct.values.category_name){
        fetchAllSubCategories(addNewProduct.values.category_name)
      }
       if(addNewProduct.values.subcategory_name){
        fetchAllProductTypes(addNewProduct.values.subcategory_name)
      }
       if(addNewProduct.values.product_type_name){
        fetchAllSeries(addNewProduct.values.product_type_name)
      }
      if(addNewProduct.values.product_series_name){
        fetchAllSubSeries(addNewProduct.values.product_series_name)
      }
  },[
    addNewProduct.values.category_name,
    addNewProduct.values.subcategory_name,
    addNewProduct.values.product_type_name,
    addNewProduct.values.product_series_name,
    show])
  // Handle product categories
  async function fetchAllCategories() {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await fetchProductCategoryApi(authToken);
      if (response?.code == 200) {
        setProductCategories(response.data);
      }
    } catch (error) {}
  }
  async function handleAddCategory(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }

      let response = await handleAddCategoryApi(values, authToken);
      if (response?.code == 200) {
            setErrorMessage("");
            setSuccessMessage(response.message);
            fetchAllCategories();
      } else {
            setSuccessMessage("");
            setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }

  // Handle product Sub categories
  async function fetchAllSubCategories(mainCategoryId) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await fetchProductSubCategoryApi(authToken,mainCategoryId);
      if (response?.code == 200) {
        setProductSubCategories(response.data);
      }
    } catch (error) {}
  }
  async function handleAddSubCategory(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }

      let response = await handleAddSubCategoryApi(values, authToken);
      if (response?.code == 200) {
            setErrorMessage("");
            setSuccessMessage(response.message);
            fetchAllSubCategories();
      } else {
            setSuccessMessage("");
            setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }

  // Handle product types
  async function fetchAllProductTypes(subCategoryId) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await fetchProductTypeApi(authToken,subCategoryId);
      if (response?.code == 200) {
        setProductType(response.data);
      }
    } catch (error) {}
  }
  async function handleAddProductType(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }

      let response = await handleAddProductTypeApi(values, authToken);
      if (response?.code == 200) {
            setErrorMessage("");
            setSuccessMessage(response.message);
            fetchAllProductTypes();
      } else {
            setSuccessMessage("");
            setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }

  // Handle product series
  async function fetchAllSeries(productTypeId) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await fetchProductSeriesApi(authToken,productTypeId);
      if (response?.code == 200) {
        setProductSeries(response.data);
      }
    } catch (error) {}
  }
  async function handleAddProductSeries(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }

      let response = await handleAddProductSeriesApi(values, authToken);
      if (response?.code == 200) {
            setErrorMessage("");
            setSuccessMessage(response.message);
            fetchAllSeries();
      } else {
            setSuccessMessage("");
            setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }

  // Handle product series sub series
  async function fetchAllSubSeries(mainSeriesId) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }
      let response = await fetchProductSubSeriesApi(authToken,mainSeriesId);
      if (response?.code == 200) {
        setProductSubSeries(response.data);
      }
    } catch (error) {}
  }
  async function handleAddProductSubSeries(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }

      let response = await handleAddSubSeriesApi(values, authToken);
      if (response?.code == 200) {
            setErrorMessage("");
            setSuccessMessage(response.message);
            fetchAllSubSeries();
      } else {
            setSuccessMessage("");
            setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }
  const productCategoryOption = useMemo(()=>{
    return productCategories
  },[productCategories])
  const productSubCategoryOption = useMemo(()=>{
    return productSubCategories
  },[productSubCategories])
  const productTypeOption = useMemo(()=>{
    return productTypes
  },[productTypes])
  const productSeriesOption = useMemo(()=>{
    return productSeries
  },[productSeries])
  const productSubSeriesOption = useMemo(()=>{
    return productSubSeries
  },[productSubSeries])
  // <-----------------------END------------------------------>
  
  async function handleAddManufacture(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }

      let response = await handleAddVendorApi(values, authToken);
      if (response?.code == 200) {
            setErrorMessage("");
            setSuccessMessage(response.message);
            fetchAllActiveManufacturer();
      } else {
            setSuccessMessage("");
            setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }

  async function handleAddDistributor(values) {
    try {
      if (!authToken) {
        throw new Error("Token not found.");
      }

      let response = await handleAddEditDistributorApi(values, authToken);
      if (response?.code == 200) {
            setErrorMessage("");
            setSuccessMessage(response.message);
            fetchAllActiveDistributor();
      } else {
            setSuccessMessage("");
            setErrorMessage(response?.message || "");
      }
    } catch (error) {
      console.log(error.message);
      setSuccessMessage("");
      setErrorMessage("Something went wrong");
    }
  }


  const formattedManufacturer = useMemo(()=>{
    if(!Array.isArray(activeVendors)){
      return []
    }
    return activeVendors?.map((item)=>({value : item.id, label :item.name}))
  },[activeVendors])

  const formattedDistributors = useMemo(()=>{
      if(!Array.isArray(activeDistributors)){
        return []
      }
      const activeDistributorArr = [...activeDistributors]

      const formattedArray = activeDistributorArr?.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      formattedArray.unshift({ value: '', label: 'No Distributor' });
      return formattedArray;
  },[activeDistributors])


  

  // Function handle open & close modal
  const toggle = () => {
    let isMainProduct = false;
    if(selectedItem =='Products'){
       isMainProduct = true
    }
    setIsMainProductActive(isMainProduct)

    setModal(!modal);
    if (!modal) {
      // # Reset form to initial values when modal is closed
      addNewProduct.resetForm();
      // setIsMainProductActive(true )
      // setStoreTags([]);
      // setAttributeValues({});
      // setErrorMessage("");
      // setSuccessMessage("");
      // setStoreProductImages([]);
      // setSelectedVendor(null);
      // setSelectedDistributor(null)
      // setSelectedDistributorPrice('')
      // setSelectedDistributorLeadTime('')
      // setSelectedDistributorCurrency({});

      
      // setSelectedDistributors([]);
      // setSelectedProducts([])
      // setProductDetails({})
      // setIsProductEdit(false)
    }
  };
  useEffect(()=>{
    if(!modal){
      setIsMainProductActive(true )
      setStoreTags([]);
      setAttributeValues({});
      setErrorMessage("");
      setSuccessMessage("");
      setStoreProductImages([]);
      setSelectedVendor(null);
      setSelectedDistributor(null)
      setSelectedDistributorPrice('')
      setSelectedDistributorLeadTime('')
      setSelectedDistributorCurrency({});
      setSelectedVendorCurrency({})
      setIsDistributorAlreadyExist(false);
      setIsDistributorAlreadyExist(false)
      setSelectedDistributors([]);
      setSelectedProducts([])
      setProductDetails({})
      setIsProductEdit(false)
    }
  },[modal])

  // Function handle open & close sub product  modal
  const handleShowViewModal = () => setSubProductViewModal(!subProductViewModal);
  


  // Function for handle selected Manufacture
  const handleManufactureSelectChange = (selectedOption) => {
   
    if(!selectedOption){
      setSelectedDistributors([])
      setSelectedDistributorCurrency({});
      setSelectedDistributorPrice('');
      setSelectedDistributorLeadTime('')
    }
    setSelectedVendor(selectedOption);
  };

  // Function for handle selected distributor
  const handleDistributorSelectChange = (selectedOption) => {
        let isDistributorAlreadyExist = false
          if(selectedOption){
            isDistributorAlreadyExist  = selectedDistributors?.find((item)=>{
              return item.label == selectedOption.label
          })  
        }
      
      if(isDistributorAlreadyExist){
            setIsDistributorAlreadyExist(true);
            const selectedCurrency  =  memoizedCurrencyData.find((item)=>(item.value  === isDistributorAlreadyExist.currency?.value))
            setSelectedDistributorCurrency(selectedCurrency)
            setSelectedDistributorPrice(isDistributorAlreadyExist?.price)
            setSelectedDistributorLeadTime(isDistributorAlreadyExist?.lead_time)
      }else{
            setIsDistributorAlreadyExist(false);
            setSelectedDistributorCurrency({});
            setSelectedDistributorPrice('');
            setSelectedDistributorLeadTime('')
      }
      setSelectedDistributor(selectedOption);

  };

  // Function for change products status 
  const handleChangeProductStatus = async(productId) =>{
    try{

      let response = await handleChangeProductStatusApi(productId, authToken);
      if (response?.code == 200) {
            const updatedProducts = products?.map((item)=>
            productId == item.id ?  {...item,status : item.status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'} : item)
            setAllProducts(updatedProducts)
      } 
    }catch(error){
        console.log("error",error);
    }
  }

  // Function for add selected distributor 
  const addSelectedDistributor = () =>{
    const isDistributorAlreadyExist  = selectedDistributors?.find((item)=>{
       return item.label == selectedDistributor.label
    })  


    if(selectedDistributorPrice !=='' && selectedDistributorLeadTime !=='' && Object.keys(selectedDistributorCurrency)?.length !==0){
      if(isDistributorAlreadyExist){
        setSelectedDistributors((prev)=>
          prev.map((item)=>
              item.id == selectedDistributor.value ?
                {
                    ...item,
                    price :  selectedDistributorPrice,
                    currency : selectedDistributorCurrency,
                    lead_time : selectedDistributorLeadTime
                } : item
          )
        )
        toast.success(`${selectedDistributor.label} successfully updated`)
        return
      }else{

        selectedDistributor.id = selectedDistributor.value
        selectedDistributor.price = selectedDistributorPrice
        selectedDistributor.currency = selectedDistributorCurrency
        selectedDistributor.lead_time = selectedDistributorLeadTime
        setSelectedDistributors((prev)=>([...prev, selectedDistributor]))
        toast.success(`${selectedDistributor.label} successfully added`)
        return
      }

    }else{
      toast.error(`Please fill out the required fields before adding.`)
      return
    }
   
  }
  const handleSupportingProductActive = () =>{
    try{
      setIsMainProductActive(!isMainProductActive);
    }catch(error){
      console.log('error', error);
      
    }
  } 




  // Handling total shipping price
  useEffect(() => {
    let logisticsCharge = addNewProduct.values.logistic_fee;
    let customCharge = addNewProduct.values.custom_fee;
    let bufferCharge = addNewProduct.values.logistic_buffer_charge;

    let price  = selectedDistributorPrice
    if(!price){
        price = addNewProduct.values.gpl_price
    }
    if (price) {
      if (logisticsCharge <= 0) {
        logisticsCharge = 0;
      }
      if (customCharge <= 0) {
        customCharge = 0;
      }
      if (bufferCharge <= 0) {
        bufferCharge = 0;
      }
      let totalShipmentCharge = calculateTotalShipment(price, logisticsCharge, customCharge, bufferCharge);
      
      // Set the form field value
      addNewProduct.setFieldValue('total_shipment_charge', totalShipmentCharge);
    }
    
    // Dependencies: these trigger the effect when they change
  }, [
    addNewProduct.values.logistic_fee,
    addNewProduct.values.custom_fee,
    addNewProduct.values.logistic_buffer_charge,
    addNewProduct.values.gpl_price,
    selectedDistributorPrice 
  ]);


  const handleProductChange = (label, item) => {
    try{
      let isMainProduct = null;
      switch(item){
        case 'PRODUCTS':
          isMainProduct = true
          break;
        case 'SUPPORTING_PRODUCTS':
          isMainProduct = false
          break;
      }
      setCurrentPage(1)
      fetchAllProducts(isMainProduct)
    }catch(err){

    }
    setSelectedItem(label);
  };
  // Props 
  const openPopUpPropsObj = {
    modal,
    toggle,
    addNewProduct,
    attributeValues,
    setAttributeValues,
    setErrorMessage,
    setSuccessMessage,
    errorMessage,
    successMessage,
    setStoreTags,
    storeTags,
    storeProductImages,
    setStoreProductImages,
    memoizedCurrencyData,
    selectedVendor,
    formattedManufacturer,
    handleManufactureSelectChange,
    selectedDistributor,
    formattedDistributors,
    handleDistributorSelectChange,
    setSelectedDistributorPrice,
    setSelectedDistributorLeadTime,
    selectedDistributorPrice,
    selectedDistributorLeadTime,
    addSelectedDistributor,
    setSelectedDistributors,
    selectedDistributors,
    setSelectedDistributorCurrency,
    setSelectedDistributor,
    selectedDistributorCurrency,
    productList,
    selectedProducts,
    setSelectedProducts,
    handleAddManufacture,
    handleAddDistributor,
    handleAddCategory,
    handleAddSubCategory,
    handleAddProductType,
    handleAddProductSeries,
    handleAddProductSubSeries,
    productCategoryOption,
    productSubCategoryOption,
    productTypeOption,
    productSeriesOption,
    productSubSeriesOption,
    show, 
    setShow, 
    mode, 
    setMode,
    isMainProductActive,
    handleSupportingProductActive,
    isProductEdit,
    selectedVendorCurrency, 
    setSelectedVendorCurrency,
    distributorAlreadyExist
  }

  return (
    <div className="page-content">
      <Container fluid={true} className="subProducts">
        <Breadcrumbs
          title={appName}
          breadcrumbItem="Products"
        />
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader tag="h5" className="p-1  d-flex justify-content-between">
                <Button color="warn" onClick={toggle} style={{ background :'#0AC075', color :'#fff', marginBottom : '9px'}}>
                  Add Product
                </Button>
                <UncontrolledDropdown className="me-2" direction="down">
                  <DropdownToggle caret style={{background : '#005affd9', marginBottom : '9px'}} >
                    {selectedItem}
                  </DropdownToggle>
                  <DropdownMenu>
                  {/* style={{selectedItem == 'Products' ? '' : ''}}  */}
                    <DropdownItem   
                      style={{
                        backgroundColor: selectedItem === 'Products' ? 'antiquewhite' : ''
                      }} 
                      onClick={() => handleProductChange("Products" ,'PRODUCTS')}>
                      Products
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem  
                    style={{
                      backgroundColor: selectedItem !== 'Products' ? 'antiquewhite' : ''
                    }} 
                    onClick={() => handleProductChange("Supporting Products", 'SUPPORTING_PRODUCTS')}>
                      Supporting Products
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </CardHeader>
              <MemoisedProductOpenPopUp
                  {...openPopUpPropsObj}
              />
              <CardBody>
              <div className="table-responsive">
                <Table striped>
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Name</th>
                      <th>Part No</th>
                      <th>Category Name</th>
                      <th>Subcategory Name</th>
                      <th>Series</th>
                      <th>Sub Series</th>
                      <th>{selectedItem ==='Products' ? 'Supporting Products' : 'Parent Products'}</th>
                      <th>Edit</th>
                      <th>Product details</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.part_number}</td>
                        <td>{item.category_name}</td>
                        <td>{item.subcategory_name}</td>
                        <td>{item.product_series_name}</td>
                        <td>{item.product_subseries_name}</td>
                        <td className="d-flex justify-content-center">
                          <Button color="success" type="button" onClick={() => fetchProductRelateSubProduct(item.id)}>
                            View
                          </Button>
                        </td>
                        <td>       
                          <Button color="success" type="button" onClick={() => fetchSingleProductDetailsSubProduct(item.id, true)}>
                            Edit
                          </Button>
                        </td>
                        <td>       
                          <Button color="success" type="button" onClick={() => fetchSingleProductDetailsSubProduct(item.id, false)}>
                            View details
                          </Button>
                        </td>
                        <td className="d-flex justify-content-center">
                          <Button color={`${item.status === 'ACTIVE' ? 'success' : 'danger'}`} type="button" onClick={() => handleChangeProductStatus(item.id)}>
                            {item.status}
                          </Button>
                        </td>
                 
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <ViwPopUp
                  mode={viewMode}
                  show={subProductViewModal}
                  toggle={handleShowViewModal}
                  productData={productData}

                />
              </div>
              </CardBody>
              <div  className=" d-flex justify-content-end">
                <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages}/>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Product;

const OpenPopUp = ({
  modal,
  toggle,
  addNewProduct,
  attributeValues,
  setAttributeValues,
  setErrorMessage,
  setSuccessMessage,
  errorMessage,
  successMessage,
  setStoreTags,
  storeTags,
  storeProductImages,
  setStoreProductImages,
  options,
  memoizedCurrencyData,
  selectedVendor,
  formattedManufacturer,
  handleManufactureSelectChange,
  selectedDistributor,
  formattedDistributors,
  handleDistributorSelectChange,
  setSelectedDistributorPrice,
  setSelectedDistributorLeadTime,
  selectedDistributorPrice,
  selectedDistributorLeadTime,
  addSelectedDistributor,
  setSelectedDistributors,
  selectedDistributors,
  setSelectedDistributorCurrency,
  setSelectedDistributor,
  selectedDistributorCurrency,
  productList,
  selectedProducts,
  setSelectedProducts,
  handleAddManufacture,
  handleAddDistributor,
  handleAddCategory,
  handleAddSubCategory,
  handleAddProductType,
  handleAddProductSeries,
  handleAddProductSubSeries,
  productCategoryOption,
  productSubCategoryOption,
  productTypeOption,
  productSeriesOption,
  productSubSeriesOption,
  show, 
  setShow, 
  mode, 
  setMode,
  isMainProductActive,
  handleSupportingProductActive,
  isProductEdit,
  selectedVendorCurrency, 
  setSelectedVendorCurrency,
  distributorAlreadyExist
}) => {
  // # Tags
  const [singleInpTagValue, setSingleInputTagValue] = useState("");
  const [singleInpTagValueError, setSingleInputTagValueError] = useState("");

  // # Product image
  const [productSingleImageName, setProductSingleImageName] = useState("");
  const [productSingleImage, setProductSingleImage] = useState(null);




  const formattedProductsOptions = useMemo(()=>{
      if(isProductEdit){  
        const arrProductList =  [...productList]
        const output = arrProductList?.filter((item)=>{
          return !selectedProducts?.some((element) => Number(element.value) === item.id);
        })
        const finalData  = output?.map((item)=>(
          {
            value: item.id,
            label: item.name,
          }
        ))

        return finalData
      }else{
        return productList?.map((item, index)=>(
          {
            value: item.id,
            label: item.name,
          }
        ))
      }

  },[productList, selectedProducts, isProductEdit])

  // useEffect(()=>{

  //   if(selectedDistributors.length>0){
  //     let withoutSelectedDistributor = distributorList.filter((item)=>{
  //       // Filter out selected distributors
  //       return !selectedDistributors.some(
  //         (selectedItem) => item.value === selectedItem.value
  //       );
  //     })
  //     console.log("withoutSelectedDistributor",withoutSelectedDistributor);
      
  //      setDistributorList(withoutSelectedDistributor)
  //   }else{
  //    setDistributorList(formattedDistributors)
  //   }
  // },[selectedDistributors,formattedDistributors,selectedDistributor]) 


  // Function to handle open & close modal
  const handleShow = () => {

    
    setShow(!show);
    if (!show) {
      formikNewItemData.resetForm();
      setSingleInputTagValueError("");
      setSingleInputTagValue("");
      setProductSingleImageName("");
      setProductSingleImage(null);

    }
    setErrorMessage("")
    setSuccessMessage("")
  };
  // Handle open & close modal
  const openModal = (type) => {
    setMode(type);
    handleShow();
  };

  // config the formik for handling new item popup
  const formikNewItemData = useFormik({
    initialValues: {
      category_name : "",
      sub_category_name : "",
      sub_category_parent_id : "",
      product_type_name : "",
      product_type_sub_category_id : "",
      series_name : "",
      main_series_product_type_id : "",      
      sub_series_name : "",
      sub_series_parent_series_id : ""
    },
    onSubmit: (values) => {
      handleSubmit(values);
    },  
  });

  // Function handle form Submit
  const handleSubmit = (values) => {
    // Submission logic based on the mode
    if (mode === "CATEGORY") {
        const data ={
          name : values.category_name
        }
        handleAddCategory(data)
    } else if (mode === "SUB_CATEGORY") {
      const data ={
        name : values.sub_category_name,
        parent_id : values.sub_category_parent_id
      }
      handleAddSubCategory(data)
    } else if(mode === "PRODUCT_TYPE"){
      const data ={
        name : values.product_type_name,
        parent_id : values.product_type_sub_category_id
      }
      handleAddProductType(data)
    }else if(mode === "PRODUCT_SERIES"){
      const data ={
        name : values.series_name,
        parent_id : values.main_series_product_type_id
      }
      handleAddProductSeries(data)
    }else if(mode === "PRODUCT_SUB_SERIES"){
      const data ={
        name : values.sub_series_name,
        parent_id : values.sub_series_parent_series_id
      }
      handleAddProductSubSeries(data)
    }else if (mode === "TAG") {
      console.log("Adding Tag");
    }

  };

  // Function for handle add new tag
  const handleAddNewTag = () => {
    if (storeTags.includes(singleInpTagValue.trim())) {
      setSingleInputTagValueError(`${singleInpTagValue} already exist`);
      return;
    }
    setSingleInputTagValueError("");
    if (singleInpTagValue.trim() !== "") {
      setStoreTags((prev) => [...prev, singleInpTagValue.trim()]);
    }
  };

  // Function for handle delete tag
  const handleDeleteTag = (index) => {
    const updatedItems = storeTags.filter((item, i) => i !== index);
    setStoreTags(updatedItems);
  };

  const handleDeleteDistributor = (index)=>{
    const updatedItems = selectedDistributors.filter((item, i) => i !== index);
    if(updatedItems?.length == 0){
      setSelectedDistributorCurrency({})
      setSelectedDistributorLeadTime("")
      setSelectedDistributorPrice("")
      setSelectedDistributor({
        "value": "",
        "label": "No Distributor"
    })
     }
    setSelectedDistributors(updatedItems);
  }

  // Function for handle product add image
  const handleProductAddImage = (e) => {
    try {
      e.preventDefault();
      // Check if both name and image file are provided
      if (!productSingleImage || productSingleImageName.trim() === "") {
        console.error("Please provide both an image name and an image file.");
        return; // Exit if either the file or name is missing
      }

      // Add the new image to the stored images array
      setStoreProductImages((prev) => [
        ...prev,
        { name: productSingleImageName, file: productSingleImage },
      ]);

      // Clear the input fields after adding the image
      setProductSingleImageName(""); // Reset image name
      setProductSingleImage(null); // Reset image file
    } catch (err) {}
  };
  const handleProductSelectChange =(selected)=>{    
    setSelectedProducts(selected)
  } 

  return (
    <div>
      <Modal size="xl" isOpen={modal} toggle={toggle}>
      <div style={{maxHeight : '787px', overflow : 'auto'}}>
        <ModalHeader toggle={toggle}>{isMainProductActive ? `${isProductEdit ? 'Edit Product' : 'Add Product'}` : `${isProductEdit?  'Edit Supporting Product' : 'Add Supporting Product'}`}</ModalHeader>
        <Form onSubmit={addNewProduct.handleSubmit}>
          <ModalBody>
            <Row>
              <Col md={12}>
                {errorMessage && (
                  <span className=" invalidError d-flex justify-content-center">
                    {errorMessage}
                  </span>
                )}
                {successMessage && (
                  <span className=" successMsg d-flex justify-content-center">
                    {successMessage}
                  </span>
                )} 
              </Col> 
              <Col md={12}>
                <FormGroup>
                  <Label htmlFor="name">Name:</Label>
                  <Input
                    type="text"
                    value={addNewProduct.values.name}
                    required
                    onChange={addNewProduct.handleChange}
                    id="name"
                    name="name"
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup className="productImg">
                  <Label htmlFor="product_image">Add Product Image:</Label>
                  <div>
                    <button
                      type="button"
                      onClick={() => openModal("PRODUCT_IMAGE")}
                      className="addImgBtn"
                    >
                      <i className="bi bi-folder-plus"></i>
                    </button>
                  </div>
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <Label htmlFor="data_sheet">Data Sheet:</Label>
                  <Input
                    type="file"
                    id="data_sheet"
                    onChange={(event) =>
                      addNewProduct.setFieldValue(
                        "data_sheet",
                        event.currentTarget.files[0]
                      )
                    }
                    name="data_sheet"
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label htmlFor="user_manual">User Manual:</Label>
                  <Input
                    type="file"
                    id="user_manual"
                    onChange={(event) =>
                      addNewProduct.setFieldValue(
                        "user_manual",
                        event.currentTarget.files[0]
                      )
                    }
                    name="user_manual"
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="category_name">Category Name:</Label>
                  <div className="d-flex">
                    <select
                      className="selectInput"
                      id="category_name"
                      name="category_name"
                      value={addNewProduct.values.category_name}
                      onChange={(e) => {
                        addNewProduct.handleChange(e); // Corrected function call
                        if (e.target.value === '') {
                          addNewProduct.setFieldValue('subcategory_name', ''); 
                          addNewProduct.setFieldValue('product_type_name', ''); 
                          addNewProduct.setFieldValue('product_series_name', ''); 
                          addNewProduct.setFieldValue('product_subseries_name', ''); 
                        }
                      }}
                    >
                      <option value={""}>Select category</option>
                      {productCategoryOption?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    {addNewProduct.errors.category_name ? (
                      <span className="invalidError">
                        {addNewProduct.errors.category_name}
                      </span>
                    ) : null}

                    <button
                      className="plusButton"
                      type="button"
                      onClick={() => openModal("CATEGORY")}
                    >
                      <i className="bi bi-plus-square"></i>
                    </button>

                  </div>
                </FormGroup>
              </Col>
              {addNewProduct.values.category_name && (
                <Col md={3}>
                  <FormGroup>
                    <Label htmlFor="subcategory_name">Subcategory Name:</Label>
                    <div className="d-flex">
                      <select
                        className="selectInput"
                        id="subcategory_name"
                        name="subcategory_name"
                        value={addNewProduct.values.subcategory_name}
                        onChange={(e) => {
                          addNewProduct.handleChange(e); // Corrected function call
                          if (e.target.value === '') {
                            addNewProduct.setFieldValue('product_type_name', ''); 
                            addNewProduct.setFieldValue('product_series_name', ''); 
                            addNewProduct.setFieldValue('product_subseries_name', ''); 
                          }
                        }}
                      >
                        <option value={""}>Select sub category</option>
                        {productSubCategoryOption?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                      <button
                        className="plusButton"
                        type="button"
                        onClick={() => openModal("SUB_CATEGORY")}
                      >
                        <i className="bi bi-plus-square"></i>
                      </button>
                    </div>
                  </FormGroup>
                </Col>
              )}
              {addNewProduct.values.subcategory_name && (
                <Col md={3}>
                  <FormGroup>
                    <Label htmlFor="product_type_name">
                      Product Type Name:
                    </Label>
                    <div className="d-flex">
                      <select
                        className="selectInput"
                        id="product_type_name"
                        name="product_type_name"
                        value={addNewProduct.values.product_type_name}
                        onChange={(e) => {
                          addNewProduct.handleChange(e); // Corrected function call
                          if (e.target.value === '') {
                            addNewProduct.setFieldValue('product_series_name', ''); 
                            addNewProduct.setFieldValue('product_subseries_name', ''); 
                          }
                        }}
                      >
                        <option value={""}>Select product type</option>
                        {productTypeOption?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                      <button
                        className="plusButton"
                        type="button"
                        onClick={() => openModal("PRODUCT_TYPE")}
                      >
                        <i className="bi bi-plus-square"></i>
                      </button>
                    </div>
                  </FormGroup>
                </Col>
              )}
              {addNewProduct.values.product_type_name && (
                <Col md={3}>
                  <FormGroup>
                    <Label htmlFor="product_series_name">
                      Product Series Name:
                    </Label>
                    <div className="d-flex">
                      <select
                        className="selectInput"
                        id="product_series_name"
                        name="product_series_name"
                        value={addNewProduct.values.product_series_name}
                        onChange={(e) => {
                          addNewProduct.handleChange(e); // Corrected function call
                          if (e.target.value === '') {
                            addNewProduct.setFieldValue('product_subseries_name', ''); 
                          }
                        }}
                      >
                        <option value={""}>Select product series</option>
                        {productSeriesOption?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                      <button
                        className="plusButton"
                        type="button"
                        onClick={() => openModal("PRODUCT_SERIES")}
                      >
                        <i className="bi bi-plus-square"></i>
                      </button>
                    </div>

                  </FormGroup>
                </Col>
              )}
              {addNewProduct.values.product_series_name && (
                <Col md={3}>
                  <FormGroup>
                    <Label htmlFor="product_subseries_name">
                      Product Subseries Name:
                    </Label>
                    <div className="d-flex">
                      <select
                        className="selectInput"
                        id="product_subseries_name"
                        name="product_subseries_name"
                        value={addNewProduct.values.product_subseries_name}
                        onChange={addNewProduct.handleChange}
                      >
                        <option value={""}>Select product sub series</option>
                        {productSubSeriesOption?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                      <button
                        className="plusButton"
                        type="button"
                        onClick={() => openModal("PRODUCT_SUB_SERIES")}
                      >
                        <i className="bi bi-plus-square"></i>
                      </button>
                    </div>
            
                  </FormGroup>
                </Col>
              )}

            </Row>
             {/* Attributes */}
             {addNewProduct.values?.category_name !='' && addNewProduct.values?.category_name != 3 && (
              <Row>
                {attributes[0].name?.map((item, index) => (
                  <Col md={3} key={index}>
                    <FormGroup>
                      <Label htmlFor="category_name">{item.inputName} ({item.unit}):</Label>
                      {item.inputType == "textBox" && (
                        <Input
                          type="text"
                          value={attributeValues[item.inputName] || ""}
                          onChange={(event) =>
                            setAttributeValues((prev) => ({
                              ...prev,
                              [item.inputName]: event.target.value,
                            }))
                          }
                          id={`attributes${index}`}
                          name={`attributes${index}`}
                        />
                      )}
                    </FormGroup>
                  </Col>
                ))}
            </Row>)}

            {!isProductEdit && <Col md={12} className="mb-2" >
                  <FormGroup switch>
                    <Input
                      type="switch"
                      checked={isMainProductActive}
                      style={{width : '35px', height : '15px'}}
                      onClick={() => handleSupportingProductActive()}
                      className="me-1"
                    />
                    <Label style={{color : 'red'}} check>Add Product</Label>
                  </FormGroup>
            </Col>}

            {/* ---------------------------MAIN PRODUCT ACTIVE START---------------------- */}
             
            <Row>
             {isMainProductActive ? <Col md={3}>
                <FormGroup>
                  <Label>Select Supporting Product</Label>
                  <Select
                    isMulti
                    name="colors"
                    onChange={handleProductSelectChange}
                    value={selectedProducts} 
                    options={formattedProductsOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </FormGroup>
              </Col>
              :
              <Col md={3}>
                <FormGroup>
                  <Label>Select Parent Product</Label>
                  <Select
                    isMulti
                    name="colors"
                    onChange={handleProductSelectChange}
                    value={selectedProducts} 
                    options={formattedProductsOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </FormGroup>
              </Col>}
         
              {/* Part No */}
              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="partNumber">Part No:</Label>
                  <Input
                    type="text"
                    value={addNewProduct.values.part_number}
                    required
                    onChange={addNewProduct.handleChange}
                    id="partNumber"
                    name="part_number"
                  />
                </FormGroup>
                {addNewProduct.errors.part_number &&
                  addNewProduct.errors.part_number ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {addNewProduct.errors.part_number}
                    </div>
                  ) : null}
              </Col>
              {/* Currency */}
              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="currency">Currency:</Label>
                  <Select
                    options={memoizedCurrencyData}
                    value={selectedVendorCurrency}
                    placeholder="Select a currency..."
                    isSearchable
                    onChange={(selectedOption) =>
                      setSelectedVendorCurrency(selectedOption)
                    }
                  />
                  {addNewProduct.errors.currency &&
                  addNewProduct.touched.currency ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {addNewProduct.errors.currency}
                    </div>
                  ) : null}
                </FormGroup>
              </Col>
              {/* Manufacture */}
              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="manufacture">Manufacture:</Label>
                  <div className="d-flex">
                    <Select
                      className="w-100"
                      value={selectedVendor}
                      onChange={handleManufactureSelectChange}
                      options={formattedManufacturer}
                      // name="manufacture"
                      isClearable={true} // To allow clearing the selection
                    />
                    <button
                      className="plusButton "
                      type="button"
                      onClick={() => openModal("MANUFACTURE")}
                    >
                      <i className="bi bi-plus-square"></i>
                    </button>
                  </div>

                {addNewProduct.errors.manufacture &&
                  addNewProduct.touched.manufacture ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {addNewProduct.errors.manufacture}
                    </div>
                  ) : null}
                </FormGroup>
                
              </Col>

              {/* Distributors */}
              {selectedVendor && <Col md={3}>
                <FormGroup>
                  <Label htmlFor="distributor">Distributor:</Label>
                  <div className="d-flex">
                    <Select
                    className="w-100"
                      value={selectedDistributor}
                      onChange={handleDistributorSelectChange}
                      options={formattedDistributors}
                      isClearable={true} // To allow clearing the selection
                    />
                    <button
                        className="plusButton "
                        type="button"
                        onClick={() => openModal("DISTRIBUTOR")}
                      >
                      <i className="bi bi-plus-square"></i>
                    </button>
                  </div>
                  
                </FormGroup>
              </Col>}
              {/* Distributors Currency */}
              {selectedVendor && selectedDistributor?.value && <Col md={3}>
                <FormGroup>
                  <Label htmlFor="currency">Distributor Currency:</Label>
                  <Select
                    options={memoizedCurrencyData}
                    placeholder="Select a currency..."
                    value={selectedDistributorCurrency}
                    isSearchable
                    onChange={(selectedOption) =>
                      setSelectedDistributorCurrency(selectedOption)
                    }
                  />
                </FormGroup>
              </Col>}
              {selectedVendor && selectedDistributor?.value && <Col md={3}>
                <FormGroup>
                  <Label htmlFor="currency">Distributor Lead Time (Days):</Label>
                  <Input
                      type="number"
                      value={selectedDistributorLeadTime}
                      required
                      onChange={(e)=>{setSelectedDistributorLeadTime(e.target.value)}}
                      id="distributor_Price"
                      name="distributor_Price"
                      />
                </FormGroup>
              </Col>}
              {/* Distributor Price */}
              {selectedVendor && selectedDistributor?.value && selectedDistributorCurrency  && <Col md={3}>
                <FormGroup>
                  <Label htmlFor="distributor_Price">{selectedDistributor?.label} Price:</Label>
                  <div  className="d-flex">
                      <Input
                        type="number"
                        value={selectedDistributorPrice}
                        required
                        onChange={(e)=>{setSelectedDistributorPrice(e.target.value)}}
                        id="distributor_Price"
                        name="distributor_Price"
                      />
                      <Toaster />
                      <button
                          className={`addButton ${distributorAlreadyExist ? 'bg-danger' : 'bg-success'} `}
                          type="button"
                          onClick={addSelectedDistributor}
                        >
                          {distributorAlreadyExist ? 'Update': 'Add'}
                      </button>
                      <button
                          className="viewButton bg-secondary"
                          type="button"
                          onClick={() => openModal("VIEW_DISTRIBUTOR")}
                        >
                         View
                      </button>
                  </div>
                  
                </FormGroup>
              </Col>}
            </Row>
            {/* ----------------------- MAIN PRODUCT ACTIVE  END---------------------------- */}

            <MemoisedNewItemPopUp
                show={show}
                toggle={handleShow}
                mode={mode}
                formikNewItemData={formikNewItemData}
                singleInpTagValue={singleInpTagValue}
                setSingleInputTagValue={setSingleInputTagValue}
                storeTags={storeTags}
                handleAddNewTag={handleAddNewTag}
                handleDeleteTag={handleDeleteTag}
                singleInpTagValueError={singleInpTagValueError}
                storeProductImages={storeProductImages}
                handleProductAddImage={handleProductAddImage}
                productSingleImageName={productSingleImageName}
                setProductSingleImageName={setProductSingleImageName}
                productSingleImage={productSingleImage}
                setProductSingleImage={setProductSingleImage}
                selectedDistributors={selectedDistributors}
                handleDeleteDistributor={handleDeleteDistributor}
                errorMessage={errorMessage}
                successMessage={successMessage}
                handleAddManufacture={handleAddManufacture}
                handleAddDistributor={handleAddDistributor}
                productCategoryOption={productCategoryOption}
                productSubCategoryOption={productSubCategoryOption}
                productTypeOption={productTypeOption}
                productSeriesOption={productSeriesOption}
            />

            <Row>  
              {/* GBL price */}
              <Col md={3}>
                <Label htmlFor="gblPrice">GPL Price</Label>
                <Input
                  type="number"
                  id="gblPrice"
                  value={addNewProduct.values.gpl_price}
                  required
                  onChange={addNewProduct.handleChange}
                  name="gpl_price"
                />
              </Col>
              {/* Standard Discount (%) */}
              {/* <Col md={3}>
                <Label htmlFor="standardDiscount">Standard Discount (%)</Label>
                <Input
                  type="number"
                  id="standardDiscount"
                  value={addNewProduct.values.standard_discount}
                  required
                  onChange={addNewProduct.handleChange}
                  name="standard_discount"
                />
              </Col> */}
              {/* Standard Markup (%) */}
              {/* <Col md={3}>
                <Label htmlFor="standardMarkup">Standard Markup (%)</Label>
                <Input
                  type="number"
                  id="standardMarkup"
                  value={addNewProduct.values.standard_markup}
                  required
                  onChange={addNewProduct.handleChange}
                  name="standard_markup"
                />
              </Col> */}
              <Col md={3}>
                <FormGroup>
                  <Label htmlFor="release_date">Release Date:</Label>
                  <Input
                    type="date"
                    id="release_date"
                    
                    value={addNewProduct.values.release_date}
                    onChange={addNewProduct.handleChange}
                    name="release_date"
                  />
                </FormGroup>
              </Col>
              {/* Tags */}
              <Col md={3}>
                <FormGroup>
                  <Label className="addTagLabel">Add Tags:</Label>
                  <div className="d-flex justify-content-center">
                    <button
                      className="plusButton"
                      type="button"
                      onClick={() => openModal("TAG")}
                    >
                      <i className="bi bi-bookmark-plus"></i>
                    </button>
                  </div>
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label htmlFor="description">Description</Label>
                  <textarea
                    className="selectInput"
                    id="description"
                    name="description"
                    value={addNewProduct.values.description}
                    required
                    onChange={addNewProduct.handleChange}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
               {/* Transport Type */}
              <Col md={2}>
                <FormGroup>
                  <Label htmlFor="transportType">Transport Type:</Label>
                  <div className="d-flex">
                    <select
                      className="selectInput"
                      id="transportType"
                      name="transport_type"
                      required
                      value={addNewProduct.values.transport_type}
                      onChange={addNewProduct.handleChange}
                    >
                      <option value={""}>Select type</option>
                      {transportType?.map((item) => (
                        <option key={item.id} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                    {addNewProduct.errors.transport_type ? (
                      <span className="invalidError">
                        {addNewProduct.errors.transport_type}
                      </span>
                    ) : null}
                  </div>
                </FormGroup>
              </Col>
              {/* Logistics Fee (%) */}
              <Col md={2}>
                <FormGroup>
                  <Label for="logistic_fee">Logistics Fee (%):</Label>
                  <Input
                    id="logistic_fee"
                    type="number"
                    value={addNewProduct.values.logistic_fee || 0 }
                    onChange={addNewProduct.handleChange}
                    name="logistic_fee"
                  />
                </FormGroup>
              </Col>
              {/* Custom Fee (%) */}
              <Col md={2}>
                <FormGroup>
                  <Label for="custom_fee">Custom Fee (%):</Label>
                  <Input
                    id="custom_fee"
                    type="number"
                    value={addNewProduct.values.custom_fee || 0}
                    // required
                    onChange={addNewProduct.handleChange}
                    name="custom_fee"
                  />
                </FormGroup>
              </Col>
              {/* Logistic Buffer Charge (%) */}
              <Col md={3}>
                <FormGroup>
                  <Label for="logistic_buffer_charge">Logistic Buffer Charge (%):</Label>
                  <Input
                    id="logistic_buffer_charge"
                    type="number"
                    value={addNewProduct.values.logistic_buffer_charge || 0}
                    // required
                    onChange={addNewProduct.handleChange}
                    name="logistic_buffer_charge"
                  />
                </FormGroup>
              </Col>
              {/* Total Shipment Charge (logistic_fee+ custom_fee + buffer) */}
              <Col md={2}>
                <FormGroup>
                  <Label for="total_shipment_charge">Total Shipment Charge:</Label>
                  <Input
                    id="total_shipment_charge"
                    type="number"
                    value={addNewProduct.values.total_shipment_charge}
                    // required
                    readOnly={true}
                    // onChange={addNewProduct.handleChange}
                    name="total_shipment_charge"
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label for="lead_time">Lead time (days):</Label>
                  <Input
                    id="lead_time"
                    required
                    type="number"
                    value={addNewProduct.values.lead_time}
                    onChange={addNewProduct.handleChange}
                    name="lead_time"
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label for="warranty_period">Warranty Period (months):</Label>
                  <Input
                    id="warranty_period"
                    type="number"
                    value={addNewProduct.values.warranty_period}
                    onChange={addNewProduct.handleChange}
                    name="warranty_period"
                  />
                </FormGroup>
              </Col>
              <Col md={5}>
                <FormGroup>
                  <Label for="warranty_terms">Warranty Terms:</Label>
                  <Input
                    id="warranty_terms"
                    value={addNewProduct.values.warranty_terms}
                    onChange={addNewProduct.handleChange}
                    name="warranty_terms"
                  />
                </FormGroup>
              </Col>
              {/* <Col md={2}>
                <FormGroup>
                  <Label for="stock_quantity">Stock Quantity:</Label>
                  <Input
                    id="stock_quantity"
                    type="number"
                    value={addNewProduct.values.stock_quantity}
                    required
                    onChange={addNewProduct.handleChange}
                    name="stock_quantity"
                  />
                </FormGroup>
              </Col> */}
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary">
              Submit
            </Button>
            {/* </FormGroup> */}
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>
        </div>
      </Modal>
    </div>
  );
};
const MemoisedProductOpenPopUp = memo(OpenPopUp);




function CreateNewItemPopup({
  show,
  toggle,
  mode,
  formikNewItemData,
  singleInpTagValue,
  setSingleInputTagValue,
  storeTags,
  handleAddNewTag,
  handleDeleteTag,
  singleInpTagValueError,
  storeProductImages,
  handleProductAddImage,
  productSingleImageName,
  setProductSingleImageName,
  productSingleImage,
  setProductSingleImage,
  selectedDistributors,
  handleDeleteDistributor,
  errorMessage,
  successMessage,
  handleAddManufacture,
  handleAddDistributor,
  productCategoryOption,
  productSubCategoryOption,
  productTypeOption,
  productSeriesOption,
}) {

  
  // Handle file input change
  const handleImageChange = (e) => {
    const file = e.currentTarget.files[0]; // Get the selected file
    if (file) {
      setProductSingleImage(file); // Set the file object to state
    }
  };

  // Add Manufacture Form
  const manufactureForm = useFormik({
    initialValues: {
      name: "",
      email: "",
      contact_person: "",
      contact_no:  "",
    },
    validationSchema: Yup.object({
      contact_no: Yup.string().matches(/^\S+$/, "Spaces are not allowed"),

    }),
    onSubmit: (values) => {

      // Trim all string values
      const trimmedValues =  Object.keys(values).reduce((acc, key)=>{
        acc[key]  = typeof values[key] == 'string' ? values[key].trim() : values[key]  
        return acc
      },{})
      trimmedValues.isEdit  =  false
      handleAddManufacture(trimmedValues);
    },
  });

  // Add Distributor Form
  const distributorForm = useFormik({
    initialValues: {
      name:  "",
      email: "",
      contact_person: "",
      contact_no: "",
    },
    validationSchema: Yup.object({
      contact_no: Yup.string().matches(/^\S+$/, "Spaces are not allowed"),
    }),
    onSubmit: (values) => {

      // Trim all string values
      const trimmedValues =  Object.keys(values).reduce((acc, key)=>{
          acc[key]  = typeof values[key] == 'string' ? values[key].trim() : values[key]  
          return acc
      },{})
      trimmedValues.isEdit  =  false
      handleAddDistributor(trimmedValues);
    },
  });

  
  return (
    <Modal size={mode === "VIEW_DISTRIBUTOR" ? 'lg' : 'md'} isOpen={show} toggle={toggle}>
      <div className="modal-header">
        <h5 className="modal-title">
          {mode === "CATEGORY"
            ? "Add Category"
            : mode === "SUB_CATEGORY"? 
            "Add Subcategory"
            : mode === "TAG"?
             "Add Tag"
            : mode === "PRODUCT_IMAGE"?
            "Add Product Image" : 
            mode ==="PRODUCT_TYPE"?
            "Add Product Type" :
            mode ==="PRODUCT_SERIES"?
            "Add Product Series" :
            mode ==="PRODUCT_SUB_SERIES"?
            "Add Product Sub Series" : ""
            }
        </h5>
        <Button onClick={toggle} close />
      </div>
      {mode !=='MANUFACTURE'  && mode !=='DISTRIBUTOR'&& <Form onSubmit={formikNewItemData.handleSubmit}>
        <div className={`newItemModalBody ${mode === "VIEW_DISTRIBUTOR" ? 'p-5': ''}`}>

                {errorMessage && (
                  <span className=" invalidError d-flex justify-content-center">
                    {errorMessage}
                  </span>
                )}
                {successMessage && (
                  <span className=" successMsg d-flex justify-content-center">
                    {successMessage}
                  </span>
                )}

          {/* Category Form */}
          {mode === "CATEGORY" && (
            <FormGroup className="ms-5">
              <Label for="category_name">Enter Category Name</Label>
              <Input
                type="text"
                name="category_name"
                className="w-75 "
                value={formikNewItemData.values.category_name}
                onChange={formikNewItemData.handleChange}
                id="popup_category_name"
                required
              />
            </FormGroup>
          )}

          {/* Subcategory Form */}
          {mode === "SUB_CATEGORY" && (
            <>
              <FormGroup className="ms-5">
                <Label for="sub_category_name">Enter Sub Category Name</Label>
                <Input
                  type="text"
                  name="sub_category_name"
                  className="w-75 "
                  value={formikNewItemData.values.sub_category_name}
                  onChange={formikNewItemData.handleChange}
                  id="sub_category_name"
                  required
                />
              </FormGroup>
              <FormGroup className="ms-5">
                <Label for="sub_category_parent_id">Select Category</Label>
                <Input
                  type="select"
                  required
                  className="w-75 "
                  value={formikNewItemData.values.sub_category_parent_id}
                  onChange={formikNewItemData.handleChange}
                  name="sub_category_parent_id"
                  id="sub_category_parent_id"
                >
                  <option value={""}>Select category</option>
                  {productCategoryOption?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </>
          )}

          {/* Subcategory Form */}
          {mode === "PRODUCT_TYPE" && (
            <>
              <FormGroup className="ms-5">
                <Label for="product_type_name">Enter Product Type </Label>
                <Input
                  type="text"
                  name="product_type_name"
                  className="w-75 "
                  value={formikNewItemData.values.product_type_name}
                  onChange={formikNewItemData.handleChange}
                  id="product_type_name"
                  required
                />
              </FormGroup>
              <FormGroup className="ms-5">
                <Label for="product_type_sub_category_id">Select Sub Category</Label>
                <Input
                  type="select"
                  required
                  className="w-75 "
                  value={formikNewItemData.values.product_type_sub_category_id}
                  onChange={formikNewItemData.handleChange}
                  name="product_type_sub_category_id"
                  id="product_type_sub_category_id"
                >
                  <option value={""}>Select Sub Category</option>
                  {productSubCategoryOption?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </>
          )}

          {/* Subcategory Form */}
          {mode === "PRODUCT_SERIES" && (
            <>
              <FormGroup className="ms-5">
                <Label for="series_name">Enter Series</Label>
                <Input
                  type="text"
                  name="series_name"
                  className="w-75 "
                  value={formikNewItemData.values.series_name}
                  onChange={formikNewItemData.handleChange}
                  id="series_name"
                  required
                />
              </FormGroup>
              <FormGroup className="ms-5">
                <Label for="series_product_type_id">Select Product Type</Label>
                <Input
                  type="select"
                  required
                  className="w-75 "
                  value={formikNewItemData.values.main_series_product_type_id}
                  onChange={formikNewItemData.handleChange}
                  name="main_series_product_type_id"
                  id="series_product_type_id"
                >
                  <option value={""}>Select Product Type</option>
                  {productTypeOption?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </>
          )}

          {/* Subcategory Form */}
          {mode === "PRODUCT_SUB_SERIES" && (
            <>
              <FormGroup className="ms-5">
                <Label for="sub_series_name">Enter Sub Series Name</Label>
                <Input
                  type="text"
                  name="sub_series_name"
                  className="w-75 "
                  value={formikNewItemData.values.sub_series_name}
                  onChange={formikNewItemData.handleChange}
                  id="sub_series_name"
                  required
                />
              </FormGroup>
              <FormGroup className="ms-5">
                <Label for="sub_series_main_series_id">Select Parent Series</Label>
                <Input
                  type="select"
                  required
                  className="w-75 "
                  value={formikNewItemData.values.sub_series_parent_series_id}
                  onChange={formikNewItemData.handleChange}
                  name="sub_series_parent_series_id"
                  id="sub_series_main_series_id"
                >
                  <option value={""}>Select category</option>
                  {productSeriesOption?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </>
          )}

          {/* Tags Form */}
          {mode === "TAG" && (
            <>
              <FormGroup className="ms-5">
                <Label for="tag">Tag Name</Label>
                <div className="d-flex">
                  <Input
                    type="text"
                    name="tag"
                    id="tag"
                    className="w-75 "
                    value={singleInpTagValue}
                    onChange={(e) => {
                      setSingleInputTagValue(e.target.value);
                    }}
                    required
                  />
                  <Button
                    type="button"
                    color="primary"
                    onClick={handleAddNewTag}
                  >
                    Add Tag
                  </Button>
                </div>
                {singleInpTagValueError && (
                  <span className="invalidError">{singleInpTagValueError}</span>
                )}
              </FormGroup>

              <ul className="list-container">
                {storeTags?.map((item, index) => (
                  <li key={index} className="list-item">
                    <span className="item-text">{item}</span>
                    <button
                      className="delete-button"
                      onClick={() => handleDeleteTag(index)}
                    >
                      <i className="bi bi-trash"></i>
                    </button>
                  </li>
                ))}
              </ul>
            </>
          )}
          {/* Product image  */}
          {mode === "PRODUCT_IMAGE" && (
            <>
              <div className="productImageContainer">
                <div className="productImageContainerSub d-flex">
                  {/* <form onSubmit={handleProductAddImage}> */}

                  <div className="w-75">
                    <div className="productEleWrapperName">
                      <Label htmlFor="productImageName">Name:</Label>
                      <Input
                        type="text"
                        name="productImageName"
                        id="productImageName"
                        value={productSingleImageName}
                        onChange={(e) => {
                          setProductSingleImageName(e.target.value);
                        }}
                        // required
                      />
                    </div>
                    {productSingleImage && (
                      <div className="productSingleImagePreview">
                        <img
                          src={URL.createObjectURL(productSingleImage)}
                          alt="Product image Preview"
                          className="productImagePreview"
                        />
                      </div>
                    )}
                    <div className="productEleWrapperImage">
                      <Label htmlFor="productImageName">Image:</Label>
                      <Input
                        type="file"
                        name="productImage"
                        id="productImage"
                        onChange={handleImageChange}
                        // required
                      />
                    </div>
                  </div>
                  <div className="addImageBtn">
                    <Button
                      type="button"
                      onClick={handleProductAddImage}
                      color="primary"
                    >
                      Add Image
                    </Button>
                  </div>
                  {/* </form> */}
                </div>
              </div>

              <ul className="list-container-product-image ">
                {storeProductImages?.map((item, index) => (
                  <li key={index}>
                    {item.file !== "" && (
                      <>
                        <img
                          src={typeof item?.file == 'string' ? item?.file :  URL.createObjectURL(item?.file)}
                          alt="image Preview"
                          className="productImagePreview"
                        />
                        <div className="imageName">
                          <span>{item.name}</span>
                        </div>
                      </>
                    )}
                  </li>
                ))}
              </ul>
            </>
          )}
          {/* View Distributor */}
          {mode === "VIEW_DISTRIBUTOR" &&(
            <>
            <Table bordered >
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Name</th>
                  <th>Currency</th>
                  <th >Lead Time (Days)</th>
                  <th>Price</th>
                  <th></th>
                </tr>
             </thead>
             <tbody>
             {selectedDistributors?.map((item, index) => (
                <tr key={index}>
                  <td>{index+1}</td>
                  <td>{item.label}</td>
                  <td>{item.currency.value}</td>
                  <td>{item.lead_time}</td>
                  <td>{item.price}</td>
                  <td>
                  <button
                      className="delete-button"
                      onClick={() => handleDeleteDistributor(index)}
                    >
                      <i className="bi bi-trash"></i>
                    </button>
                  </td>
                 
                </tr>
                ))}
             </tbody>
            </Table>
            </>
          )}

        </div>
        <div className="modal-footer">
          {(mode == "CATEGORY" || mode == "SUB_CATEGORY" || mode == "PRODUCT_TYPE" || mode == "PRODUCT_SERIES" || mode == "PRODUCT_SUB_SERIES") && (
            <Button type="submit" color="primary">
              {mode === "CATEGORY"
                ? "Add Category"
                : mode === "SUB_CATEGORY"
                ? "Add Subcategory"
                : mode ==="PRODUCT_TYPE"?
                 "Add Product Type":
                mode ==="PRODUCT_SERIES"?
                "Add Product Series" :
                mode ==="PRODUCT_SUB_SERIES"?
                "Add Product Sub Series" : "" 
                }
            </Button>
          )}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </div>
      </Form>}
      {mode === "MANUFACTURE" && (
          <Form onSubmit={manufactureForm.handleSubmit}>
            <Col md={12}>
                {errorMessage && (
                  <span className=" invalidError d-flex justify-content-center">
                    {errorMessage}
                  </span>
                )}
                {successMessage && (
                  <span className=" successMsg d-flex justify-content-center">
                    {successMessage}
                  </span>
                )}
              </Col>
           <Row className="d-flex justify-content-center">

              <Col md={8}>
                <FormGroup>
                  <Label htmlFor="vendor_name">Name:</Label>
                  <Input
                    type="text"
                    value={manufactureForm.values.name}
                    required
                    onChange={manufactureForm.handleChange}
                    id="vendor_name"
                    name="name"
                  />
                </FormGroup>
              </Col>
              <Col md={8}>
                <FormGroup>
                  <Label htmlFor="vendor_email">Email:</Label>
                  <Input
                    type="email"
                    id="vendor_email"
                    value={manufactureForm.values.email}
                    required
                    onChange={manufactureForm.handleChange}
                    name="email"
                  />
                </FormGroup>
              </Col>
              <Col md={8}>
                <FormGroup>
                  <Label htmlFor="vendor_contact_person">Contact Person:</Label>
                  <Input
                    type="text"
                    value={manufactureForm.values.contact_person}
                    required
                    onChange={manufactureForm.handleChange}
                    id="vendor_contact_person"
                    name="contact_person"
                  />
                </FormGroup>
              </Col>
              <Col md={8}>
                <FormGroup>
                  <Label htmlFor="vendor_contact_number">Contact Number:</Label>
                  <Input
                    type="text"
                    value={manufactureForm.values.contact_no}
                    required
                    onChange={manufactureForm.handleChange}
                    id="vendor_contact_number"
                    name="contact_no"
                  />
                </FormGroup>
                {manufactureForm.errors.contact_no &&
                  manufactureForm.errors.contact_no ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {manufactureForm.errors.contact_no}
                    </div>
                  ) : null}
              </Col>
              <div className="modal-footer">
                <Button type="submit" color="primary">
                    Submit
                </Button>
                <Button color="secondary" onClick={toggle}>
                  Cancel
                </Button>
              </div>
           </Row>
          </Form>
      )}
      {mode === "DISTRIBUTOR" && (
          <Form onSubmit={distributorForm.handleSubmit}>
            <Col md={12}>
                {errorMessage && (
                  <span className=" invalidError d-flex justify-content-center">
                    {errorMessage}
                  </span>
                )}
                {successMessage && (
                  <span className=" successMsg d-flex justify-content-center">
                    {successMessage}
                  </span>
                )}
              </Col>
           <Row className="d-flex justify-content-center">

              <Col md={8}>
                <FormGroup>
                  <Label htmlFor="distributer_name">Name:</Label>
                  <Input
                    type="text"
                    value={distributorForm.values.name}
                    required
                    onChange={distributorForm.handleChange}
                    id="distributer_name"
                    name="name"
                  />
                </FormGroup>
              </Col>
              <Col md={8}>
                <FormGroup>
                <Label htmlFor="distributer_email">Email:</Label>
                  <Input
                    type="email"
                    id="distributer_email"
                    value={distributorForm.values.email}
                    required
                    onChange={distributorForm.handleChange}
                    name="email"
                  />
                </FormGroup>
              </Col>
              <Col md={8}>
                <FormGroup>
                  <Label htmlFor="vendor_contact_person">Contact Person:</Label>
                  <Input
                    type="text"
                    value={distributorForm.values.contact_person}
                    required
                    onChange={distributorForm.handleChange}
                    id="vendor_contact_person"
                    name="contact_person"
                  />
                </FormGroup>
              </Col>
              <Col md={8}>
                <FormGroup>
                <Label htmlFor="dist_contact_number">Contact Number:</Label>
                  <Input
                    type="text"
                    value={distributorForm.values.contact_no}
                    required
                    onChange={distributorForm.handleChange}
                    id="dist_contact_number"
                    name="contact_no"
                  />
                </FormGroup>
                {distributorForm.errors.contact_no &&
                  distributorForm.errors.contact_no ? (
                    <div className=" invalidError d-flex justify-content-center">
                      {distributorForm.errors.contact_no}
                    </div>
                  ) : null}
              </Col>
              <div className="modal-footer">
                <Button type="submit" color="primary">
                    Submit
                </Button>
                <Button color="secondary" onClick={toggle}>
                  Cancel
                </Button>
              </div>
           </Row>
          </Form>
      )}
    </Modal>
  );
}
// Memoizing component
const MemoisedNewItemPopUp = memo(CreateNewItemPopup);


const ViwPopUp = ({ mode, show, toggle, productData }) => {


  

  return (
    <Modal size={productData.length !==0 ? 'xl' : 'md' } fullscreen={false} isOpen={show} toggle={toggle}>
    
      <ModalBody className="p-5">
      {mode === "PRODUCT_RELATE_SUB_PRODUCTS" && (
          Array.isArray(productData) && productData?.length !== 0 ? (
          <Table bordered>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Name</th>
                <th>Image</th>
                <th>Part No</th>
                <th>Manufacture</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {productData?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>
                  <td>
                    {item.image ?<img
                      className="listItemImage"
                      src={item.image}
                      alt={`${item.name} product image`}
                    /> : 
                    <img
                      className="listItemImage"
                      src={PlaceholderImg}
                      alt={`${item.name} product image`}
                    />
                   }
                  </td>
                  <td>{item.part_number}</td>
                  <td>{item.manufacture}</td>
                  <td>{item.description}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div className="p-5 d-flex justify-content-center align-items-center">
            <h1>
              <b>No item found</b>
            </h1>
          </div>
        )
      )}

      {mode === "PRODUCT_DETAILS" &&  Array.isArray(productData) && productData?.length !== 0 && (
        <>
        <h5 className="text-info">Product Details</h5>
        
        {productData?.map((item, index) => (
          <div key={index} className="mb-4">
            <Row>
              {/* You can wrap each label-value pair inside a Col */}
              <Col md={6}>
                <strong>Manufacturer:</strong> {item.manufacturer.name}
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <strong>GPL Price:</strong> {item.gpl_price}
              </Col>
              <Col md={6}>
                <strong>Logistics Fee (%):</strong> {item.logistic_fee}
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <strong>Release Date:</strong> {item.release_date}
              </Col>
              <Col md={6}>
                <strong>Logistic Buffer Charge (%):</strong> {item.logistic_buffer_charge}
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <strong>Transport Type:</strong> {item.transport_type}
              </Col>
              <Col md={6}>
                <strong>Custom Fee (%):</strong> {item.custom_fee}
              </Col>
            </Row>
            <Row>
            <Col md={6}>
                <strong>Warranty Period (months):</strong> {item.warranty_period}
              </Col>

              <Col md={6}>
                <strong>Warranty Terms:</strong> {item.warranty_terms}
              </Col>
            </Row>
            {/* <Row>
              <Col md={6}>
                <strong>Lead Time (days):</strong> {item.lead_time}
              </Col>

            </Row> */}
            <Row>
              <Col md={6}>
                <strong>Height(cm):</strong> {item.attributes?.Height}
              </Col>
              <Col md={6}>
                <strong>Length(cm):</strong> {item.attributes?.Length}
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <strong>Weight(kg):</strong> {item.attributes?.Weight}
              </Col>
              <Col md={6}>
                <strong>Width(cm):</strong> {item.attributes?.Width}
              </Col>
            </Row>

          </div>
        ))}
        {productData?.[0]?.distributors?.length !==0 && <>
          <h5 className="text-info">Distributors</h5>
          <Row>
              <Table striped>
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productData?.[0]?.distributors?.map((item) => (
                      <tr>
                          <td>{item.code}</td>
                          <td> {item.name} - {item.price} {item.currency}</td>
                      </tr>
                    ))}
                  </tbody>
              </Table>
          </Row>
        </>}
      

        {productData?.[0]?.additional_tags?.length !==0 &&
          <>
          
            <Row>
              <h5 className="text-info">Tags</h5>
              <ul className="ms-5">
                  {productData?.[0]?.additional_tags?.map((tag, index) => (
                    // <Col key={index} md={12}>
                      <li key={index}>{tag}</li>
                    // </Col>
                  ))}
              </ul>
   
            </Row>
          </>
        }
        </>
      )}

      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
